import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import parameters from '@atlassian/jira-relay/src/__generated__/BacklogAggAppDataQuery$parameters';

export const nextGenBacklogEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-next-gen-backlog-entrypoint" */ './src/ui/backlog/index.tsx'
			),
		{ entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
		const { context, tenantContext } = entryPointRouteParams;
		const routeName = context.route.name;

		if (
			(routeName !== 'rapidboard-backlog' &&
				routeName !== 'rapidboard-user-backlog' &&
				routeName !== 'rapidboard-backlog-embed') ||
			!fg('backlog_relay_data_resource')
		) {
			return {};
		}

		return {
			queries: {
				backlogDataQuery: {
					parameters,
					variables: {
						boardId: `ari:cloud:jira-software:${tenantContext.cloudId}:board/${context.match.params.boardId}`,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
